module.exports = __webpack_public_path__ + "img/GBM1_pDC.74e88d67.png";